import { WarningMessage } from '@common/components';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { TranscriptsView } from '@/enums';
import useTranslation from '@/hooks/useTranslation';

interface ConfirmDeleteConversationsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  conversationCount: number;
  activeView: TranscriptsView;
  isLoading?: boolean;
}

export default function ConfirmDeleteConversationsModal({
  isOpen,
  onClose,
  onConfirm,
  conversationCount,
  activeView,
  isLoading = false,
}: ConfirmDeleteConversationsModalProps) {
  const { lang } = useTranslation();

  return (
    <AlertDialog open={isOpen}>
      <AlertDialogContent className="sm:max-w-[425px]">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            {lang.get('msg.confirmDeletion')}
          </AlertDialogTitle>
          <AlertDialogDescription className="flex flex-col gap-2 text-dark-text">
            {lang.get('msg.areYouSureYouWantToDelete')} {conversationCount}{' '}
            {lang.get(`msg.conversation${conversationCount > 1 ? 's' : ''}`).toLowerCase()}?
          </AlertDialogDescription>
        </AlertDialogHeader>

        <WarningMessage>
          <div>
            {lang.get('msg.deletingConversationsWarning')}
            {activeView === TranscriptsView.COMPLETED && (
              <span className="ml-1">{lang.get('msg.deletingCompletedConversationsWarning')}</span>
            )}
          </div>
        </WarningMessage>

        <AlertDialogFooter className="mt-5">
          <AlertDialogCancel onClick={onClose} disabled={isLoading}>
            {lang.get('msg.cancel')}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={isLoading}
            className="bg-red-600 hover:bg-red-700"
          >
            {lang.get('msg.delete')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
